import { render, staticRenderFns } from "./code-item.vue?vue&type=template&id=45745f42&scoped=true"
import script from "./code-item.vue?vue&type=script&lang=js"
export * from "./code-item.vue?vue&type=script&lang=js"
import style0 from "./code-item.vue?vue&type=style&index=0&id=45745f42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45745f42",
  null
  
)

export default component.exports